import { t } from "@lingui/macro";

import { PageHero, Prose } from "../_components/page-shell";

export const PrivacyPolicyPage = () => {
  return (
    <>
      <PageHero
        eyebrow={t`Legal`}
        title={t`Privacy Policy`}
        subtitle={t`How Izicvs collects, uses and protects your data.`}
      />
      <Prose>
        <p>{t`Last updated: this policy may be updated from time to time. When we make material changes, we will update this page and, where appropriate, notify you.`}</p>

        <h2>{t`Introduction`}</h2>
        <p>{t`Izicvs is an AI powered job search and resume platform operated by Nextilabs. This Privacy Policy explains what information we collect, how we use it, and the choices you have. By using Izicvs, you agree to the practices described here.`}</p>

        <h2>{t`Information we collect`}</h2>
        <p>{t`We collect the following categories of information so that we can provide and improve our services:`}</p>
        <ul>
          <li>{t`Account information, such as your name, email address, and authentication details.`}</li>
          <li>{t`Resume content, including the work history, skills, and other details you add to build or analyze your documents.`}</li>
          <li>{t`Usage data, such as pages viewed, features used, device information, and general analytics about how you interact with the product.`}</li>
        </ul>

        <h2>{t`How we use your information`}</h2>
        <p>{t`We use your information to create and manage your account, generate resume analyses and job matches, provide customer support, secure the platform, and improve our features. We may also use it to communicate service updates and, where you have consented, product news.`}</p>

        <h2>{t`AI processing`}</h2>
        <p>{t`To generate analyses, suggestions, and job matches, we send relevant resume and job data to trusted AI providers that process it on our behalf. This data is not used to train third party models, and it is never resold. Processing is limited to delivering the features you request.`}</p>

        <h2>{t`Data sharing`}</h2>
        <p>{t`We do not sell your personal data. We share information only with service providers and processors who help us operate Izicvs, such as hosting, analytics, and AI processing partners, and only under agreements that protect your data. We may also disclose information where required by law.`}</p>

        <h2>{t`Data retention`}</h2>
        <p>{t`We keep your information for as long as your account is active or as needed to provide the service. When you delete your account, we remove or anonymize your personal data within a reasonable period, unless we are required to retain it for legal or security reasons.`}</p>

        <h2>{t`Your rights`}</h2>
        <p>{t`Depending on your location, you may have the right to access, correct, export, or delete your personal data, and to object to or restrict certain processing. If you are in the European Union, you benefit from the protections of the GDPR. You can exercise these rights at any time by contacting us.`}</p>

        <h2>{t`Security`}</h2>
        <p>{t`We apply technical and organizational measures, including encryption in transit, access controls, and regular reviews, to protect your data. No system is perfectly secure, but we work continuously to keep your information safe.`}</p>

        <h2>{t`Contact`}</h2>
        <p>{t`If you have questions about this Privacy Policy or how we handle your data, please contact us at privacy@izicvs.com.`}</p>
      </Prose>
    </>
  );
};
